import Drake from "./Celebrity-NFT/Drake.png";
// import Eminem from "./Celebrity-NFT/Eminem.jpg";
import Tyler from "./Celebrity-NFT/Feliciathegoat.jpg";
import Frank from "./Celebrity-NFT/FrankOcean.png";
import IceCube from "./Celebrity-NFT/IceCube.png";
import Jcole from "./Celebrity-NFT/JCole.jpg";
import Jason from "./Celebrity-NFT/JasonDerulo.jpg";
import Juice from "./Celebrity-NFT/Juice.png";
import Kanye from "./Celebrity-NFT/Kanye.jpg";
import Kendrick from "./Celebrity-NFT/KendrickLamar.png";
import LilNas from "./Celebrity-NFT/LilNas.jpg";
import Nicki from "./Celebrity-NFT/NickiMinaj.jpg";
import Nipsey from "./Celebrity-NFT/NipseyHussle.jpg";
// import PopSmoke from "./Celebrity-NFT/PopSmoke.jpg";
// import PostMalone from "./Celebrity-NFT/PostMalone.jpg";
import Rema from "./Celebrity-NFT/Rema.jpg";
import Rihana from "./Celebrity-NFT/Rihanna.jpg";
import Snoop from "./Celebrity-NFT/SnoopDoggfinal.png";
import TheWeekend from "./Celebrity-NFT/TheWeeknd.jpg";
import Travis from "./Celebrity-NFT/TravisScott.png";
import Artist from "./Celebrity-NFT/avatar.png";
import Steph from "../BasketballArt/Basketball-NFT/Steph.jpg";
import Paraphase from "../RandomArt/RandomArt-NFT/PARAPHASE.jpg";
const items = [
  {
    id: 1,
    title: "Rema",
    artist: "Femi",
    artistImage: Artist,
    image: Rema,
    info: "Digital art of Rema from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 2,
    title: "Drake",
    artist: "Femi",
    artistImage: Artist,
    image: Drake,
    info: "Digital art of Drake from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },

  {
    id: 3,
    title: "Tyler",
    artist: "Femi",
    artistImage: Artist,
    image: Tyler,
    info: "Digital art of Tyler the creator from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 4,
    title: "Frank.O",
    artist: "Femi",
    artistImage: Artist,
    image: Frank,
    info: "Digital art of Frank Ocean from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 5,
    title: "Ice.C",
    artist: "Femi",
    artistImage: Artist,
    image: IceCube,
    info: "Digital art of Ice Cube from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 6,
    title: "Jcole",
    artist: "Femi",
    artistImage: Artist,
    image: Jcole,
    info: "Digital art of J Cole from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 7,
    title: "Jason.D",
    artist: "Femi",
    artistImage: Artist,
    image: Jason,
    info: "Digital art of Jason Derulo from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 8,
    title: "Juice.W",
    artist: "Femi",
    artistImage: Artist,
    image: Juice,
    info: "Digital art of Juice Wurld from our Celebrity collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 9,
    title: "Kanye.W",
    artist: "Femi",
    artistImage: Artist,
    image: Kanye,
    info: "Digital art of Kanye West from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 10,
    title: "Kendrick.L",
    artist: "Femi",
    artistImage: Artist,
    image: Kendrick,
    info: "Digital art of Kendrick Lamar from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 11,
    title: "Lil Nas",
    artist: "Femi",
    artistImage: Artist,
    image: LilNas,
    info: "Digital art of Lil Nas from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 12,
    title: "Nicki.M",
    artist: "Femi",
    artistImage: Artist,
    image: Nicki,
    info: "Digital art of Nicki Minaj from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 13,
    title: "Nipsey.H",
    artist: "Femi",
    artistImage: Artist,
    image: Nipsey,
    info: "Digital art of Nipsey Hussle from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },

  {
    id: 14,
    title: "Rihana",
    artist: "Femi",
    artistImage: Artist,
    image: Rihana,
    info: "Digital art of Rihana from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 15,
    title: "Snoop.D",
    artist: "Femi",
    artistImage: Artist,
    image: Snoop,
    info: "Digital art of Snoop Doog from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 16,
    title: "Weekend",
    artist: "Femi",
    artistImage: Artist,
    image: TheWeekend,
    info: "Digital art of The Weekend from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 17,
    title: "Travis.S",
    artist: "Femi",
    artistImage: Artist,
    image: Travis,
    info: "Digital art of Travis Scott from our Celebrity collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Celebrity Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
];
export default items;
